module.exports = __webpack_public_path__ + "static/media/aachen.0654dc73.jpg";